import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '@service/util/util.service';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';

@Component({
	selector: 'app-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmationDialogComponent implements OnInit {
	@Input() showCloseButton: boolean = true;
	@Input() buttonActionLayout: string = 'end end';
	@Input() headerClass: string = '';
	@Input() confirmationText: string = null;
	@Input() confirmationTextClass: string = '';
	@Input() allowHtmlEdit: boolean = false;
	@Input() flipActions = false;

	IS_NOT_EMPTY = IS_NOT_EMPTY;

	quillToolbar = [
		['bold', 'italic', 'underline', 'strike'],
		[{ list: 'ordered' }, { list: 'bullet' }],
		[{ header: [1, 2, 3, 4, 5, 6, false] }],
	];
	htmlTemplate: string = '';

	constructor(
		public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private sanitizer: DomSanitizer,
		public utilService: UtilService
	) {}

	ngOnInit() {
		if (this.data.allowHtmlEdit) {
			this.allowHtmlEdit = this.data.allowHtmlEdit;
			this.htmlTemplate = this.data.body;
		}
		if (!this.utilService.isNullOrUndefined(this.data.showCloseButton)) {
			this.showCloseButton = this.data.showCloseButton;
		}
		if (!this.utilService.isNullOrUndefined(this.data.buttonActionLayout)) {
			this.buttonActionLayout = this.data.buttonActionLayout;
		}
	}

	closeDialog(): void {
		this.dialogRef.close(null);
	}

	confirm(): void {
		if (!this.allowHtmlEdit) {
			this.dialogRef.close(true);
		} else {
			this.dialogRef.close(this.htmlTemplate);
		}
	}

	ngOnChanges() {
		this.data.body = this.sanitizer.bypassSecurityTrustHtml(this.data.body) as string;
	}
}
